// $(document).ready(function(){
//   $("a.sliderow__title.sliderow__title--secondary:contains('Trade')").parent().addClass("trade-menu");
  
//   $('br').attr('aria-hidden', 'true');
//   $('.menu__item.grandparent.kids-1 > a').removeAttr('href');
//   $('.menu__item.parent > a').removeAttr('href');

//     $('.drawer__bottom__left label.social-label').click(function(){
//     $('.drawer__bottom .social-link-wrap').slideToggle();
//     })
// $('.header__mobile__hamburger').click(function() {
//   $('body').toggleClass('z-inddown');
// });
// });

// var firstLink = document.querySelector('.kids-2 a');
// if (firstLink) {
//   firstLink.removeAttribute('href');
// }




$('a').each(function () {
  // Check if the link is external
  if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'https://www.houseofleon.com') {
    // Create a span element with warning text
    var warningSpan = $('<span class="visuallyhidden">: This link will open in a new tab.</span>');
    // Set attributes for accessibility
    $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
    // Append the warning span inside the link
    $(this).append(warningSpan);
  }
});



document.addEventListener('DOMContentLoaded', function() {
  var backToTopButton = document.getElementById('back-to-top');
  
  window.addEventListener('scroll', function() {
      if (window.scrollY > 300) {
          backToTopButton.style.display = 'block';
      } else {
          backToTopButton.style.display = 'none';
      }
  });
  
  backToTopButton.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // Set focus to the top of the page after scrolling
      setTimeout(function() {
          document.getElementById('backtoheader').focus(); // Ensure this element exists
      }, 600); // Adjust the timeout duration to match the scroll duration
  });
});





$(".px-look__overlay-box").on("click", function () {
  lastFocusedButton = $(this);
  setTimeout(function () {
    $("#close-button").attr("tabindex", 0).focus();
  }, 1000);
});

$("#close-button").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus();
    }
  }, 1000);
});









$(".popout__toggle").on("click", function () {
  lastFocusedButton = $(this);
  setTimeout(function () {
    $(".collection__sidebar__head").attr("tabindex", 0).focus();
  }, 1000);
});

// $('.accordion-row .accordion-toggle').click(function (e) {
//   e.preventDefault();

//   let $this = $(this);
//   let $content = $this.next('.accordion-content');

//   // Close all other accordion contents
//   $('.accordion-row .accordion-content').not($content).slideUp(300);
//   $('.accordion-row .accordion-toggle').not($this).removeClass('is-open').attr('aria-expanded', 'false');

//   Toggle current accordion content
//   if ($this.hasClass('is-open')) {
//     $this.removeClass('is-open').attr('aria-expanded', 'false');
//     // $content.slideUp(300);
//   } else {
//     $this.addClass('is-open').attr('aria-expanded', 'true');
//     // $content.slideDown(300);
//   }
// });



// $('.accordion .accordion__title').click(function (e) {
//   e.preventDefault();

//   let $this = $(this);
//   let $content = $this.next('.accordion-content');

//   // Close all other accordion contents
//   $('.accordion-row .accordion-content').not($content).slideUp(300);
//   $('.accordion-row .accordion-toggle').not($this).removeClass('is-open').attr('aria-expanded', 'false');

//   // Toggle current accordion content
//   if ($this.hasClass('is-open')) {
//     $this.removeClass('is-open').attr('aria-expanded', 'false');
//     $content.slideUp(300);
//   } else {
//     $this.addClass('is-open').attr('aria-expanded', 'true');
//     $content.slideDown(300);
//   }
// });



$(".slideup").on("click", function () {
  lastFocusedButton = $(this);
  setTimeout(function () {
    $(".rebuy-cart__flyout-close").attr("tabindex", 0).focus();
  }, 1000);
});

$(".rebuy-cart__flyout-close").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus();
    }
  }, 1000);
});










document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.product-item.large-up--one-quarter').forEach(function(item) {
    item.removeAttribute('aria-hidden');
  });
});



$(".header__desktop__button").on("click", function () {
  lastFocusedButton = $(this);
  setTimeout(function () {
    $(".rebuy-cart__flyout-close").attr("tabindex", 0).focus();
  }, 1000);
});

$(".rebuy-cart__flyout-close").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus();
    }
  }, 1000);
});


$(".wishlist-page-widget").on("click", function () {
  lastFocusedButton = $(this);
  setTimeout(function () {
    $(".sewp-close").attr("tabindex", 0).focus();
  }, 1000);
});

$(".sewp-close").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus();
    }
  }, 1000);
});


$(".slideup").on("click", function () {
  lastFocusedButton = $(this);
  setTimeout(function () {
    $(".selector-wrapper").attr("tabindex", 0).focus();
  }, 1000);
});

$(".selector-wrapper").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus();
    }
  }, 1000);
});


$('.collection__sidebar__heading').click(function (e) {
  e.preventDefault();
  $(this).attr('aria-expanded', function (i, attr) {
    return attr == 'true' ? 'false' : 'true'
  });
});

$(".globo-formbuilder-open").on("click", function () {
  lastFocusedButton = $(this);
  setTimeout(function () {
    $(".globo-heading").attr("tabindex", 0).focus();
  }, 1000);
});

$(".globo-heading").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus();
    }
  }, 1000);
});





$('.accordion-row .accordion-toggle').click(function (e) {
  e.preventDefault();

  const $this = $(this);

  $this.toggleClass('is-open')
       .attr('aria-expanded', (i, attr) => attr === 'true' ? 'false' : 'true');
});

 //faq
$('.accordion .accordion__title').click(function (e) {
  e.preventDefault();

  const $this = $(this);

  $this.toggleClass('is-open')
       .attr('aria-expanded', (i, attr) => attr === 'true' ? 'false' : 'true');
});


// $(document).ready(function() {
//   $('.thumb__link__image').each(function(index) {
//     $(this).attr('alt', 'Ingresso Accent Chair - Image ' + (index + 1) + ' of ' + $('.thumb__link__image').length);
//   });
// });






$(document).ready(function() {
  var totalImages = $('.thumb__link__image').length;

  $('.thumb__link__image').each(function(index) {
    var originalAlt = $(this).attr('alt'); // Get the alt text already set in Liquid
    var newAlt = originalAlt + ' - Image ' + (index + 1) + ' of ' + totalImages;
    $(this).attr('alt', newAlt);
  });
});

// Get the share button element
const shareButton = document.querySelector('.product__sharing-button');

// Get the sharing div that will be collapsed/expanded
const sharingDiv = document.querySelector('.sharing');

// Add a click event listener to the share button
shareButton.addEventListener('click', function () {
  // Toggle the aria-expanded attribute between 'true' and 'false'
  const isExpanded = shareButton.getAttribute('aria-expanded') === 'true';
  
  // Update the aria-expanded attribute
  shareButton.setAttribute('aria-expanded', !isExpanded);


});

// ADA Fix: Add accessible labels to slider navigation buttons
$(document).ready(function() {
  function addSliderLabels() {
    $('.flickity-button.previous:not([aria-label])').attr('aria-label', 'Previous slide');
    $('.flickity-button.next:not([aria-label])').attr('aria-label', 'Next slide');
    
    // Add labels to pagination dots if present
    $('.flickity-page-dots .dot:not([aria-label])').each(function(index) {
      $(this).attr('aria-label', 'Go to slide ' + (index + 1));
    });
  }

  // Run on load
  addSliderLabels();

  // Run when sliders are initialized or changed (using MutationObserver for dynamic content)
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        shouldUpdate = true;
      }
    });
    if (shouldUpdate) {
      addSliderLabels();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
